import React from 'react';
import AuthUserContext from './context';
import { withFirebase } from '../firebase';
const withAuthentication = Component => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        authUser: null,
      };
    }
    attachAuthListener = () => {
      if (!this.props.firebase || !this.props.firebase.auth) {
        this.listener = null;
        this.setState({ authUser: null });
        return;
      }

      this.listener = this.props.firebase.auth.onAuthStateChanged(
        authUser => {
          authUser
            ? this.setState({ authUser })
            : this.setState({ authUser: null });
        },
      );
    };
    componentDidMount() {
      this.attachAuthListener();
    }
    componentDidUpdate(prevProps) {
      if (prevProps.firebase !== this.props.firebase) {
        if (this.listener) this.listener();
        this.setState({ authUser: null });
        this.attachAuthListener();
      }
    }
    componentWillUnmount() {
      if (this.listener) this.listener();
    }
    render() {
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }
  return withFirebase(WithAuthentication);
};
export default withAuthentication;
